export default "__VITE_ASSET__t6v4ldg3__"